import * as types from '../actions/actionTypes.js';
import { createSelector } from 'reselect';
import {getCategoryTitleFromState, getPatternTitle} from "./selectors";

export const categoriestrail = (navigation, action, stolo) => {

    let newState;
    const state = {stolo: stolo};

    switch ( action.type ) {

        case types.NAVIGATED_TO_TOPCATEGORIES:
            newState = [];
            newState.push(Object.assign({}, { type:action.type, payload: action.payload}));
            return newState;

        case types.NAVIGATED_TO_SUBCATEGORIES:

            if (navigation.length > 0) {
                newState = navigation.slice(0,1);
                const CategoryTitle = getCategoryTitleFromState(state, action.payload.categoryid);
                newState.push(Object.assign({}, { type:action.type, payload: action.payload, title: CategoryTitle }));
                return newState;
            }
            return [];

        case types.NAVIGATED_TO_CATEGORIE_PATTERNS_GALLERY:

            if (navigation.length === 2) {
                newState = navigation.slice(0);
                const CategoryTitle = getCategoryTitleFromState(state, action.payload.categoryid);
                newState.push(Object.assign({}, { type:action.type, payload: action.payload, title: CategoryTitle }));
                return newState;
            }
            return [];

        case types.NAVIGATED_TO_SINGLE_PATTERN_VIEW:

            if (navigation.length > 2) {
                newState = navigation.slice(0,3);
                const PatternTitle = getPatternTitle(state, action.payload.patternid);
                newState.push(Object.assign({}, { type:action.type, payload: action.payload, title: PatternTitle }));
                return newState;
            }
            return [];

        default:
            return navigation;
    }
};

export const getCategoriesTrail = (state) => state.stolo.navigation.categoriestrail;



// WEBPACK FOOTER //
// ./src/reducers/categoriestrail.js